import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sticky-navbar"
export default class extends Controller {
  static targets = ["content"]
  static values = {
    step: { type: Number, default: 100 }
  }


  connect() {
    this.element.style.opacity = "0"
    window.addEventListener("scroll", this.checkSticky)


    this.updateButtons()
    window.addEventListener("resize", this.updateButtons)
  }

  disconnect() {
    window.removeEventListener("scroll", this.checkSticky)
    window.removeEventListener("resize", this.updateButtons)
  }

  scrollLeft() {
    this.scroll(-this.stepValue)
  }

  scrollRight() {
    this.scroll(this.stepValue)
  }

  scroll(amount) {
    this.contentTarget.scrollBy({
      left: amount,
      behavior: "smooth"
    })
  }

  updateButtons = () => {
    console.log(this.contentTarget)
    const hasOverflow =
      this.contentTarget.scrollWidth > this.contentTarget.clientWidth

    this.element
      .querySelectorAll(".scroll-left, .scroll-right")
      .forEach(button => {
        button.style.display = hasOverflow ? "" : "none"
      })
  }

  checkSticky = () => {
    const isSticky = this.element.getBoundingClientRect().top === 0
    this.element.style.opacity = isSticky ? "1" : "0"
  }
}
